import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export default {
	name: 'InfoEventoCalendario',
	props: ['eventoInfo', 'loading','isReadOnly'],
	emits: ['click:close', 'click:edit-evento', 'click:delete-evento'],
	computed: {
		dataEventoFormatada() {
			const dataInicio = this.eventoInfo?.extendedProps?.dataEventoInicio
				? dayjs(this.eventoInfo.extendedProps.dataEventoInicio)
						.tz('America/Sao_Paulo')
						.toDate()
				: null
			const dataFim = this.eventoInfo?.extendedProps?.dataEventoFim
				? dayjs(this.eventoInfo?.extendedProps?.dataEventoFim)
						.tz('America/Sao_Paulo')
						.toDate()
				: null

			if (!dataInicio || !dataFim) return ''

			return this.formatarIntervaloDeData(dataInicio, dataFim)
		},

		locationEventoFormatada() {
			return this.eventoInfo?.extendedProps?.localEvento || ''
		},

		organizadorEvento() {
			if (this.eventoInfo?.extendedProps?.isOrganizador) {
				return 'Você é o organizador'
			}
			return 'Você não é o organizador'
		},
		textoBotaoCancelar() {
			if (this.eventoInfo?.extendedProps?.isEventoPassado) {
				return 'Excluir'
			}

			return this.isCancelarEvento ? 'Descartar' : 'Cancelar'
		},
		textoBotaoEditar() {
			return this.isCancelarEvento ? 'Enviar' : 'Editar'
		},
		iconeBotaoCancelar() {
			return this.isCancelarEvento ? 'icon_cross_fechar' : 'icon_lixeira'
		},
		membrosEvento() {
			if (this.eventoInfo?.extendedProps?.membrosEventos) {
				return this.eventoInfo?.extendedProps?.membrosEventos
			}
		},
		isEventoPassado() {
			return this.eventoInfo?.extendedProps?.isEventoPassado || false
		},
	},
	data() {
		return {
			model: {
				textoMensagemExclusao: '',
			},
			isCancelarEvento: false,
		}
	},

	methods: {
		formatarIntervaloDeData(dataInicio, dataFim) {
			const opcoesData = {
				day: 'numeric',
				month: 'long',
				year: 'numeric',
			}

			const opcoesHora = {
				hour: '2-digit',
				minute: '2-digit',
				hour12: false,
			}

			const formatadorData = new Intl.DateTimeFormat('pt-BR', opcoesData)
			const formatadorHora = new Intl.DateTimeFormat('pt-BR', opcoesHora)

			const dataFormatada = formatadorData.format(dataInicio)
			const horaInicioFormatada = formatadorHora.format(dataInicio)
			const horaFimFormatada = formatadorHora.format(dataFim)

			if (this.eventoInfo?.extendedProps?.isDiaInteiro) {
				return `${dataFormatada} (Dia inteiro)`
			}

			return `${dataFormatada} ${horaInicioFormatada} - ${horaFimFormatada}`
		},
		onClickChangeEvento() {
			if (this.isCancelarEvento) {
				this.onClickCancelarEvento()
				return
			}

			this.onClickEditarEvento()
		},
		onClickDeletarEvento() {
			if (this.isEventoPassado) {
				this.onClickCancelarEvento()
				return
			}

			this.isCancelarEvento = !this.isCancelarEvento
		},
		onClickEditarEvento() {
			this.$emit('click:edit-evento', this.eventoInfo?.id || null)
		},
		onClickCancelarEvento() {
			const idEvento = this.eventoInfo?.extendedProps?.idEventoOriginal || null
			const mensagemExclusao = this.model.textoMensagemExclusao || ''

			this.$emit('click:delete-evento', idEvento, mensagemExclusao)
		},
	},

	template: `
        <section 
            class="
                flex 
                flex-col
                relative 
                rounded-md 
                !w-full
                !max-w-[19rem]
                !h-auto
                !min-h-max
                overflow-hidden
                bg-white
                border
                border-neutral-50
                "
                >

            <q-btn icon="close" size="28" rounded class="absolute top-4 right-4 text-primary-pure"  @click="$emit('click:close')"/>

            <div class="bg-primary-pure w-full h-4 rounded-t">
            </div>

            <div class="
                flex
                flex-col
                !gap-y-16
                h-auto
                min-h-max 
                overflow-hidden 
                mt-10 
                border 
                border-transparent">

                <div class="flex-1 px-20">

                    <h1 class="text-headline-3 text-neutral-70 ">Calendário</h1>

                    <p class="text-title-3 mt-8">{{eventoInfo?.title || ""}}</p>

                    <q-btn
                        v-if="eventoInfo?.extendedProps?.urlTeams" 
                        color="primary" 
                        :href="eventoInfo?.extendedProps?.urlTeams || ''"
                        target="_blank"
                        class="btn !h-[46px] !mt-24 !rounded-lg">
                        <q-icon size="sm">
							<svg>
								<use xlink:href="#icon_camera"></use>
							</svg>
						</q-icon>
                        <span class="text-paragraph-2 text-white">Ingressar</span>
                    </q-btn>
                        
                </div>

                <div class="bg-neutral-40 w-full h-1 rounded"></div>

                <div v-if="dataEventoFormatada" class="flex flex-col flex-1 px-20 pb-20 !gap-y-16"> 

                    <div v-if="dataEventoFormatada" class="flex items-center w-full gap-12">
                        <q-icon size="sm" class="text-neutral-70">
							<svg>
								<use xlink:href="#icon_relogio"></use>
							</svg>
						</q-icon>	

                        <p class="text-paragraph-3 text-bold text-neutral-100">{{dataEventoFormatada || ''}}</p>
                    </div>

                    <div v-if="locationEventoFormatada" class="bg-neutral-40 w-full h-1 rounded"></div>

                    <div v-if="locationEventoFormatada" class="flex items-center w-full gap-12">
                        <q-icon size="sm" class="text-neutral-70">
							<svg>
								<use xlink:href="#icon_localizacao"></use>
							</svg>
						</q-icon>	

                        <p class="text-paragraph-3 text-bold text-neutral-100">{{locationEventoFormatada || ''}}</p>
                    </div>

                    <div v-if="membrosEvento && membrosEvento.length > 0" class="bg-neutral-40 w-full h-1 rounded"></div>

                    <div v-if="membrosEvento && membrosEvento.length > 0" class="flex items-start w-full gap-12">
                       <q-icon size="sm" class="text-neutral-70">
							<svg>
								<use xlink:href="#icon_usuarios_grupo"></use>
							</svg>
						</q-icon>	

                        <div class="flex flex-col flex-1 !gap-y-4">
                            <p class="text-paragraph-3 text-bold text-neutral-100">Acompanhamento</p>
                            <div class="w-full h-full !max-h-[9rem] overflow-y-auto">
                                <q-list :padding="false" dense>
                                    <q-item v-for="(membro, index) in membrosEvento || []" :key="index" dense class="!p-0">
                                         <q-item-section>
                                            <q-item-label class="text-paragraph-3 text-neutral-70">{{membro.email}} - {{membro.status}}</q-item-label>
                                         </q-item-section>
                                    </q-item>
                                </q-list>
                            </div>
                            
                        </div>
                    </div>

                    <div v-if="isCancelarEvento && isEventoPassado" class="bg-neutral-40 w-full h-1 rounded"></div>


                    <div v-show="isCancelarEvento && !isEventoPassado" class="flex items-start w-full gap-12">
                        <q-icon size="28px" class="text-white">
							<svg>
								<use xlink:href="#icon_cross_fechar"></use>
							</svg>
						</q-icon>	

                        <div>
                            <p class="text-headline-2 text-neutral-100">Cancelar o evento e notificar os participantes.</p>
                                <q-input
                                    v-model="model.textoMensagemExclusao"
                                    label="Adicione uma mensagem (opcional)"
                                    type="textarea"
                                    bg-color="neutral-20"
                                    rounded
                                    class="!min-h-[5.5rem] !rounded-lg mt-16"
                                    />                                  
                        </div>
                    </div>

                    <div class="bg-neutral-40 w-full h-1 rounded !mt-16"></div>
                    
                    <div v-if="!isReadOnly" class="flex justify-start w-full gap-16">
                        <div class="flex-1 flex items-center w-full !gap-x-20">
                            <q-btn
                                :class="{'secondary': !isCancelarEvento}" 
                                :disabled="loading && isEventoPassado" 
                                :loading="loading && !isEventoPassado"
								style="height: 44px;" 
                                class="btn w-max !rounded-lg"
                                @click="onClickChangeEvento">
									<div class="flex justify-between items-center !w-full h-full !gap-x-8">
										<q-icon name="edit" size="16px"/>
										<span class="text-paragraph-2 text-bold">{{textoBotaoEditar}}</span>
									</div>
                            </q-btn>
                            <q-btn 
                            	:class="{'secondary': isCancelarEvento, 'bg-white': !isCancelarEvento}"
                                class="btn w-max !min-h[44px] !border !border-neutral-40 hover:!border-transparent group !rounded-lg"
                                style="height: 44px; border: 1px solid; border-color: #E1E3E5 !important;" 
                                :disabled="loading && !isEventoPassado"
                                :loading="loading && isEventoPassado"
                                @click="onClickDeletarEvento" 
                                >
                                	<div class="flex justify-between items-center w-full h-full !gap-x-8">
										<q-icon v-if="isCancelarEvento" name="delete" size="sm"/>

										<q-icon v-else size="16px" class="!text-white group-hover:!text-primary-10">
											<svg>
												<use xlink:href="#icon_cross_fechar"></use>
											</svg>
										</q-icon>	

                                    	<span 
											:class="{'text-primary-pure': isCancelarEvento, 'text-neutral-80 group-hover:!text-primary-pure': !isCancelarEvento}"
											class="text-paragraph-2 text-bold">{{textoBotaoCancelar}}</span>
									</div>
                            </q-btn>
                        </div>
                    </div>
                   
                </div>

            </div>
        </section>
    `,
}
